import { render, staticRenderFns } from "./SACColorPicker.vue?vue&type=template&id=3ce88beb"
import script from "./SACColorPicker.vue?vue&type=script&lang=js"
export * from "./SACColorPicker.vue?vue&type=script&lang=js"
import style0 from "./SACColorPicker.vue?vue&type=style&index=0&id=3ce88beb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports